import { render } from "./LoaderDisplay.vue?vue&type=template&id=7422afc5&scoped=true"
const script = {}

import "./LoaderDisplay.vue?vue&type=style&index=0&id=7422afc5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7422afc5"]])

export default __exports__